import Snack from '@/components/controls/Snackbar'

export function snackPlugin(Vue) {
    const SnackComponent = Vue.extend(Snack)

    Vue.prototype.$snack = function(params = {}) {
     const s=new SnackComponent({
            parent: this.$root,
            propsData: {

                params
            }
        })
        s.$mount()
        document.body.appendChild(s.$el)



    }
}
